"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetDocumentByDocumentUrn = exports.useDocumentName = exports.getDocumentUrnOfIssue = void 0;
var _hooks = require("../../state/redux/hooks");
var _documents = require("../../state/redux/ducks/documents");
var _react = _interopRequireDefault(require("react"));
var _pushpinHelpers = require("../data/pushpinHelpers");
var _issuesCollection = require("../../state/redux/ducks/issuesCollection");
var _useSheetAssociationForIssue = require("../../IssueDetailPanel/IssueDetailTabPanel/hooks/PlacementFieldHooks/useSheetAssociationForIssue");
var _useTranslations = require("../i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getDocumentUrnOfIssue = issue => {
  if (!issue) {
    return undefined;
  }
  if ((0, _pushpinHelpers.hasLinkedDocument)(issue)) {
    return (0, _pushpinHelpers.getLinkedDocument)(issue).urn;
  }
  return null;
};
exports.getDocumentUrnOfIssue = getDocumentUrnOfIssue;
const useGetDocumentByDocumentUrn = () => {
  const documentsByUrn = (0, _hooks.useSelector)(_documents.getDocumentsByUrn);
  return _react.default.useCallback(documentUrn => documentUrn ? documentsByUrn[documentUrn] : documentUrn, [documentsByUrn]);
};
exports.useGetDocumentByDocumentUrn = useGetDocumentByDocumentUrn;
const useDocumentName = issueId => {
  const issue = (0, _hooks.useSelector)(_issuesCollection.getIssueById)(issueId);
  const {
    sheet,
    document
  } = (0, _useSheetAssociationForIssue.useSheetAssociationForIssue)({
    issue
  });
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const fileName = (document === null || document === void 0 ? void 0 : document.name) || T.translate("issueEditForm.placement.missingDocumentNamePrompt");
  const sheetName = sheet ? sheet.name + (sheet.title ? " (".concat(sheet.title, ")") : "") : T.translate("issueEditForm.placement.missingSheetNamePrompt");
  let placementText;
  if (document) {
    var _document$version$ver;
    // @ts-ignore TODO: remove this once docs updates document.version to include versionNumber prop.
    placementText = "".concat(fileName, " ").concat((_document$version$ver = document.version.versionNumber) !== null && _document$version$ver !== void 0 ? _document$version$ver : "");
  } else if (sheet) placementText = sheetName;
  return placementText;
};
exports.useDocumentName = useDocumentName;
//# sourceMappingURL=documentHooks.js.map